import Main from '@/components/main';
// import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  lv: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [{
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录',
    hideInMenu: true
  },
  component: () =>
            import('@/view/login/login.vue')
},
{
  path: '/',
  name: '_home',
  redirect: '/datainfo/data1',
  component: Main,
  meta: {
    hideInMenu: true,
    notCache: true
  },
  children: [{
    path: '/home',
    name: 'home',
    meta: {
      hideInMenu: true,
      title: '首页',
      notCache: true,
      icon: 'md-home'
      // lv: ['001']
    },
    component: () => import('@/view/single-page/home')
  }]
},

{
  path: '/setting',
  name: 'setting',
  meta: {
    icon: 'md-menu',
    title: '系统设置'
  },
  component: Main,

  children: [{
    path: 'sysconfig',
    name: 'sysconfig',
    meta: {
      icon: 'md-funnel',
      title: '初始配置',
      access: 9
    },
    component: () => import('@/view/caijisystem/sysconfig.vue')
  },
  {
    path: 'ruleconfig1',
    name: 'rule1',
    meta: {
      icon: 'md-funnel',
      title: '58转让规则',
      access: 9
    },
    component: () => import('@/view/caijisystem/ruleconfig1.vue')
  },
  {
    path: 'ruleconfig2',
    name: 'rule2',
    meta: {
      icon: 'md-funnel',
      title: '58生意转让新版规则',
      access: 9
    },
    component: () => import('@/view/caijisystem/ruleconfig2.vue')
  }
  // {
  //   path: 'ruleconfig3',
  //   name: 'rule3',
  //   meta: {
  //     icon: 'md-funnel',
  //     title: '百姓网转让规则',
  //     access: 9
  //   },
  //   component: () => import('@/view/caijisystem/ruleconfig3.vue')
  // }
  ]
},
{
  path: '/manage',
  name: 'manage',
  meta: {
    icon: 'md-menu',
    title: '信息管理'
  },
  component: Main,
  children: [
    {
      path: 'allselect',
      name: 'allselect',
      meta: {
        icon: 'md-funnel',
        title: '保护汇总',
        access: 9
      },
      component: () => import('@/view/caijisystem/allselected.vue')
    },
    {
      path: 'allnote',
      name: 'allnote',
      meta: {
        icon: 'md-funnel',
        title: '跟踪汇总',
        access: 9
      },
      component: () => import('@/view/caijisystem/allnote.vue')
    },
    {
      path: 'allblack',
      name: 'allblack',
      meta: {
        icon: 'md-funnel',
        title: '黑名单汇总',
        access: 9
      },
      component: () => import('@/view/caijisystem/allblack.vue')
    },
    {
      path: 'isblack',
      name: 'isblack',
      meta: {
        icon: 'md-funnel',
        title: '回收站',
        access: 9
      },
      component: () => import('@/view/caijisystem/alldel.vue')
    }
  ]
},
{
  path: '/datainfo',
  name: 'datainfo',
  meta: {
    icon: 'md-menu',
    title: '数据信息'
  },
  component: Main,
  children: [{
    path: 'data1',
    name: 'data1',
    meta: {
      icon: 'md-funnel',
      title: '待领取的'
    },
    component: () =>
                    import('@/view/caijisystem/lists.vue')
  },
  {
    path: 'data2',
    name: 'data2',
    meta: {
      icon: 'md-funnel',
      title: '已保护的'
    },
    component: () =>
                    import('@/view/caijisystem/selectedInfoList.vue')
  }
  ]
},
{
  path: '/usermanage',
  name: 'usermanage',
  meta: {
    icon: 'md-menu',
    title: '用户管理'
  },
  component: Main,
  children: [{
    path: 'userlist',
    name: 'userlist',
    meta: {
      icon: 'md-funnel',
      title: '用户列表',
      access: 9
    },
    component: () =>
                    import('@/view/caijisystem/userlist.vue')
  },
  {
    path: 'useradd',
    name: 'useradd',
    meta: {
      icon: 'md-funnel',
      title: '用户新增',
      access: 9
    },
    component: () =>
                    import('@/view/caijisystem/useradd.vue')
  },
  {
    path: 'useredit',
    name: 'useredit',
    meta: {
      icon: 'md-funnel',
      title: '修改用户信息',
      hideInMenu: false,
      access: 1
    },
    component: () =>
                    import('@/view/caijisystem/useredit.vue')
  }
  ]
},

{
  path: '/argu',
  name: 'argu',
  meta: {
    hideInMenu: true
  },
  component: Main,
  children: [{
    path: 'params/:id',
    name: 'params',
    meta: {
      icon: 'md-flower',
      title: route => `{{ params }}-${route.params.id}`,
      notCache: true,
      beforeCloseName: 'before_close_normal'
    },
    component: () =>
                    import('@/view/argu-page/params.vue')
  },
  {
    path: 'query',
    name: 'query',
    meta: {
      icon: 'md-flower',
      title: route => `{{ query }}-${route.query.id}`,
      notCache: true
    },
    component: () =>
                    import('@/view/argu-page/query.vue')
  }
  ]
},
{
  path: '/401',
  name: 'error_401',
  meta: {
    hideInMenu: true
  },
  component: () =>
            import('@/view/error-page/401.vue')
},
{
  path: '/500',
  name: 'error_500',
  meta: {
    hideInMenu: true
  },
  component: () =>
            import('@/view/error-page/500.vue')
},
{
  path: '*',
  name: 'error_404',
  meta: {
    hideInMenu: true
  },
  component: () =>
            import('@/view/error-page/404.vue')
}
];
